import { ReactNode, createContext, useContext } from 'react';

export interface SkilljarContextType {
  disabled: boolean;
}

export const SkilljarContext = createContext<SkilljarContextType | null>(null);

export function SkilljarContextProvider({ children }: { children: ReactNode }) {
  const params = new URLSearchParams(document.location.search);
  const skilljarContext = { disabled: params.get('skilljar') === 'false' };

  return <SkilljarContext.Provider value={skilljarContext}>{children}</SkilljarContext.Provider>;
}

export interface SendSkilljarEmbedEventParams {
  challengesPassed?: number;
  challengesTotal?: number;
  trackFinished?: boolean;
}

export function useSkilljar() {
  const skilljarContext = useContext(SkilljarContext);

  const sendSkilljarEmbedEvent = ({
    challengesPassed = 1,
    // should be greater than 0
    challengesTotal = 1,
    trackFinished = false,
  }: SendSkilljarEmbedEventParams) => {
    const parent = window.parent || window.opener;
    const parentUrl = document.referrer;

    if (!parent || !parentUrl.includes('skilljar.com') || skilljarContext?.disabled) {
      return;
    }

    parent.postMessage(
      JSON.stringify({
        mark_finished: trackFinished,
        lesson_progress_score: challengesPassed ?? 1,
        lesson_progress_max_score: challengesTotal ?? 1,
        lesson_progress_success_status: trackFinished ? 'PASSED' : '',
      }),
      '*',
    );
  };

  return { sendSkilljarEmbedEvent };
}
